import React from 'react';
import { Footer } from '../Components/Footer/Footer.js';
import './PageShowcase.css';

const featuredProjects = [
  {
    title: 'My Shop',
    description: 'E-commerce storefront focused on quick navigation, practical filtering and clear checkout flow.',
    stack: 'React, Material UI, Stripe',
  },
  {
    title: 'Ski Bookings',
    description: 'Booking platform with date-based inventory and transparent package options for visitors.',
    stack: 'React, Node.js, API Integrations',
  },
  {
    title: 'Backstreet Barbers',
    description: 'Service business website designed to drive appointments and present work in a clear format.',
    stack: 'React, Responsive CSS, Forms',
  },
  {
    title: 'SYC Review App',
    description: 'Feedback and ratings workflow with account auth and an organized review history.',
    stack: 'React, Auth, Dashboard UI',
  },
];

export const MyWorkPage = () => {
  return (
    <>
      <main className="page-shell">
        <section className="page-content">
          <div className="page-hero">
            <span className="page-kicker">Portfolio Highlights</span>
            <h1>Work that solves practical business problems</h1>
            <p>
              These projects focus on usability, clear conversion paths and maintainable front-end architecture.
              I prefer building interfaces that feel simple for users and predictable for teams.
            </p>
          </div>

          <div className="page-grid">
            {featuredProjects.map((project) => (
              <article className="page-card" key={project.title}>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <p className="page-meta">{project.stack}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};
